import { render, staticRenderFns } from "./ConferenceRoomBooking.vue?vue&type=template&id=bb8ba7fe&scoped=true&"
import script from "./ConferenceRoomBooking.vue?vue&type=script&lang=js&"
export * from "./ConferenceRoomBooking.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb8ba7fe",
  null
  
)

export default component.exports